/* eslint-disable no-script-url */
import React, { useContext, useEffect, useState } from 'react';
import { axios, endpoints } from 'Api';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Pathname } from 'Routes';
import { AppContext } from 'Context';
import { ShareScreen } from '../../../share-screen';
import 'react-notifications-component/dist/theme.css';

export default function Index() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAppSnackbar, langText, toastForGroup, setToastForGroup } = useContext(AppContext);
  const [groupCreationModalIsVisible, setGroupCreationModalVisibility] = useState(false);
  const [tempGroupCreated, setTempGroupCreationStatus] = useState(false);
  const [tempGroupID, setTempGroupID] = useState(undefined);
  const [tempGroupTitle, setTempGroupTitle] = useState(undefined);
  const [oldMembers, setOldMembers] = useState([]);
  const [oldMembersData, setOldMembersData] = useState({ members: [], pendingMembers: [] });
  const groupsText = langText?.viewersSideBar?.groups;
  const commonText = langText?.common;

  // testing
  useEffect(() => {
  }, [tempGroupCreated, tempGroupID, tempGroupTitle]);
  const revealGroupCreationModal = () => { setGroupCreationModalVisibility(true); };
  const hideGroupCreationModal = () => {
    setTempGroupID(undefined);
    setTempGroupTitle(undefined);
    setTempGroupCreationStatus(false);
    setGroupCreationModalVisibility(false);
    navigate(location.pathname);
  };

  const createGroup = async ([, setActionStatus, setOperationStatus, , , , groupTitle, groupIcon]) => {
    setTempGroupCreationStatus(true);
  };
  const getOldGroupMemebers = async () => {
    // Get group info for title
    const resp = await axios.post(endpoints.getMyGroups, { tempGroupID }).catch(() => { });
    const getGroupMembers = resp?.data;
    if (getGroupMembers?.success) {
      setTempGroupTitle(getGroupMembers?.data?.filter(({ id }) => tempGroupID === id)[0]?.title);
    }

    // Get members and pending members separately
    const membersResp = await axios.post(endpoints.getMyGroupMembers, { id: tempGroupID }).catch(() => { });
    const membersData = membersResp?.data;
    if (membersData?.success) {
      const members = membersData?.data?.members || [];
      const pendingMembers = membersData?.pending_members || [];
      // Store both separately and combined for backward compatibility
      setOldMembersData({ members, pendingMembers });
      setOldMembers([...members, ...pendingMembers]);
      console.log('Old members including pending:', [...members, ...pendingMembers]);
    }
  };
  useEffect(() => {
    if (tempGroupID) {
      getOldGroupMemebers();
    }
  }, [tempGroupID]);

  const createNewGroup = async ([onHide, setActionStatus, setOperationStatus, setSelectedUsers, setUserList, users, groupTitle, groupIcon]) => {
    setActionStatus(true);
    await axios
      .post(endpoints.addNewGroup, { title: groupTitle, image: groupIcon })
      .then(async ({ data }) => {
        setToastForGroup(data);
        if (data?.success === true) {
          setTempGroupID(data?.id);
          setTempGroupCreationStatus(true);
        } else {
          setTempGroupCreationStatus(false);
          setAppSnackbar({ isVisible: true, type: 'error', message: data?.message });
        }
      })
      .catch(() => {
        setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong' });
      });
    setActionStatus(false);
  };

  const addMembersToGroup = async ([
    onHide, setActionStatus, setOperationStatus, setSelectedUsers, setUserList, users, groupTitle, groupIcon,
  ]) => {
    setActionStatus(true);
    if (tempGroupID) {
      // Separate newly selected users:
      // Registered users = have firstname AND lastname (not empty strings)
      // Non-registered users = have empty firstname OR empty lastname
      const newUsersWithIds = users.filter((userData) => userData.firstname && userData.firstname.trim() !== ''
        && userData.lastname && userData.lastname.trim() !== '');
      const newUsersWithEmailsOnly = users.filter((userData) => !userData.firstname || userData.firstname.trim() === ''
        || !userData.lastname || userData.lastname.trim() === '');

      // eslint-disable-next-line no-console
      console.log('users', users);

      // Filter OLD MEMBERS from API response
      // Registered = have non-empty firstname AND lastname
      // Non-registered = have empty firstname OR empty lastname
      const oldRegisteredMembers = (oldMembersData.members || []).filter((member) => member.firstname && member.firstname.trim() !== ''
        && member.lastname && member.lastname.trim() !== '');
      const oldNonRegisteredMembers = (oldMembersData.members || []).filter((member) => !member.firstname || member.firstname.trim() === ''
        || !member.lastname || member.lastname.trim() === '');

      // Filter OLD PENDING MEMBERS from API response
      const oldRegisteredPending = (oldMembersData.pendingMembers || []).filter((member) => member.firstname && member.firstname.trim() !== ''
        && member.lastname && member.lastname.trim() !== '');
      const oldNonRegisteredPending = (oldMembersData.pendingMembers || []).filter((member) => !member.firstname || member.firstname.trim() === ''
        || !member.lastname || member.lastname.trim() === '');

      // Extract IDs from all REGISTERED users (old + new)
      const oldMemberIds = [
        ...oldRegisteredMembers.map((member) => member.id).filter((id) => id),
        ...oldRegisteredPending.map((member) => member.id).filter((id) => id)
      ];

      // Extract emails from all NON-REGISTERED users (old + new)
      const oldPendingEmails = [
        ...oldNonRegisteredMembers.map((member) => member.email).filter((email) => email),
        ...oldNonRegisteredPending.map((member) => member.email).filter((email) => email)
      ];

      // Combine old + new REGISTERED user IDs and remove duplicates
      const allUserIds = [
        ...oldMemberIds,
        ...newUsersWithIds.map((userData) => userData.id)
      ];
      const uniqueUserIds = [...new Set(allUserIds)];

      // Combine old + new NON-REGISTERED user emails and remove duplicates
      // Only emails that don't belong to registered users
      const allEmails = [
        ...oldPendingEmails,
        ...newUsersWithEmailsOnly.map((userData) => userData.email)
      ];
      const uniqueEmails = [...new Set(allEmails)];

      // eslint-disable-next-line no-console
      console.log('📊 Member combination:', {
        oldRegisteredUsers: oldMemberIds.length,
        oldPendingUsers: oldPendingEmails.length,
        newRegisteredUsers: newUsersWithIds.length,
        newPendingUsers: newUsersWithEmailsOnly.length,
        totalUniqueIds: uniqueUserIds.length,
        totalUniqueEmails: uniqueEmails.length,
        finalUserIds: uniqueUserIds,
        finalEmails: uniqueEmails
      });

      const requestPayload = {
        group_id: tempGroupID,
        ...(uniqueUserIds.length > 0 && { users: uniqueUserIds.join(',') }),
        ...(uniqueEmails.length > 0 && { emails: uniqueEmails.join(',') })
      };

      // eslint-disable-next-line no-console
      console.log('🚀 Sending combined members to API:', {
        ...requestPayload
      });

      const { data: createGroupMemberData } = await axios
        .post(endpoints.addMemberToGroup, requestPayload)
        .catch(() => {
          setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong' });
        });
      setUserList([]);
      if (createGroupMemberData?.success) {
        setSelectedUsers([]);
        setOperationStatus(true);
        onHide();
      } else {
        setAppSnackbar({ isVisible: true, type: 'error', message: createGroupMemberData?.message });
        setOperationStatus(false);
      }
    } else {
      await axios
        .post(endpoints.addNewGroup, { title: groupTitle, image: groupIcon })
        .then(async ({ data }) => {
          if (data?.success) {
            setTempGroupID(data?.id);
            setToastForGroup(data);
            const { data: createGroupMemberData } = await axios
              .post(endpoints.addMemberToGroup, { group_id: data?.id, users: `${users.map((userData) => userData.id)}` })
              .catch(() => {
                setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong' });
              });
            setUserList([]);
            if (createGroupMemberData?.success) {
              setTempGroupCreationStatus(false);
              setSelectedUsers([]);
              setOperationStatus(true);
              onHide();
            } else {
              setAppSnackbar({ isVisible: true, type: 'error', message: createGroupMemberData?.message });
              setOperationStatus(false);
            }
          } else {
            setAppSnackbar({ isVisible: true, type: 'error', message: data?.message });
          }
        })
        .catch(() => {
          setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong' });
        });
    }
    setActionStatus(false);
  };

  useEffect(() => {
    if (location.search?.includes(Pathname.createGroup)) {
      revealGroupCreationModal();
      setTempGroupTitle(undefined);
    } else if (location.search?.includes(Pathname.updateGroup)) {
      const selectedId = location.search.split('?');
      if (selectedId[2]) {
        setTempGroupID(selectedId[2]);
        setTempGroupCreationStatus(true);
        revealGroupCreationModal();
      }
    }
  }, [location.search]);
  // console.log('members>>', oldMembers);
  // console.log('tempGroupID', tempGroupID);
  // console.log('tempGroupCreated', tempGroupCreated);
  // console.log('groupsText', groupsText);

  return (
    <div>
      <ShareScreen
        toastForGroup={toastForGroup}
        setToastForGroup={setToastForGroup}
        actionButtonLoadingText={tempGroupCreated ? `${groupsText?.addingUsers || 'Adding Users'}...` : `${groupsText?.creatingGroup || 'Creating Group'}...`}
        actionButtonText={tempGroupCreated ? (groupsText?.addUser || 'Add Users') : (groupsText?.createGroup || 'Create Group')}
        apiEndpoint={endpoints.searchUserByEmailFromFrendList}
        errorText={tempGroupCreated ? (commonText?.somethingWentWrong || 'Oops! Something went wrong') : (groupsText?.groupNameNotAvailable || 'This group name is not available')}
        hideContent={!tempGroupCreated}
        imageEditable
        inputPlaceholder={groupsText?.searchFriend || 'Search by name or email'}
        isVisible={groupCreationModalIsVisible}
        multipleSelect
        notes={groupsText?.enterEmail || 'Enter an email to search'}
        noUsersFoundText={groupsText?.noFriend || 'No friends found with this email'}
        onContinue={tempGroupID ? (tempGroupCreated ? addMembersToGroup : createGroup) : createNewGroup}
        onHide={hideGroupCreationModal}
        // successText={tempGroupCreated ? (groupsText?.successMsg || 'Group created successfully') : (groupsText?.userSuccessMsg || 'Successfully added users to group')}
        successText={tempGroupCreated ? (groupsText?.userSuccessMsg || 'Successfully added users to group') : (groupsText?.successMsg || 'Group created successfully')}
        titleEditable={!tempGroupTitle}
        titlePlaceholder={groupsText?.groupCreatePlaceholder || 'Enter Name for the Group'}
        tempGroupTitle={tempGroupTitle}
        title={tempGroupTitle}
        oldGroupMember={oldMembers}
        oldMembersData={oldMembersData}
      />
    </div>
  );
}
